export function extractFilenameFromContentDisposition(
  headerValue?: string
): string | undefined {
  if (!headerValue) return undefined;
  const filenameMatch = headerValue.match(
    /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i
  );
  if (filenameMatch) {
    return decodeURIComponent(filenameMatch[1] || filenameMatch[2]);
  }
  return undefined;
}

export function decodeBase64ToBlob(
  base64Data: string,
  contentType = "application/pdf"
): Blob {
  const binaryString = atob(base64Data);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return new Blob([bytes], { type: contentType });
}
